import { Navigate, Outlet } from 'react-router-dom';
import { trpc } from '@/lib/trpc';
import { WinclapLoader } from '@/components/ui/winclap-loader';

/**
 * Gate de la página Office Manager. El acceso lo decide el governance
 * config-driven (`officeManager.getMyAccess`): admins/tech/people son globales
 * y las OMs entran por email aunque no tengan ningún rol ni tab:users — por
 * eso la ruta vive FUERA del bloque ProtectedRoute de /admin/users.
 */
export function OfficeManagerProtectedRoute() {
  const { data: access, isLoading } = trpc.officeManager.getMyAccess.useQuery(undefined, {
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
  // Una manager de kits (email en managers de una Clapbase) también entra,
  // aunque no esté en el governance de entregas de equipos.
  const { data: kitsAccess, isLoading: kitsLoading } = trpc.kits.getMyAccess.useQuery(undefined, {
    retry: false,
    staleTime: 5 * 60 * 1000,
  });

  if (isLoading || kitsLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <WinclapLoader size={48} className="text-foreground/25" />
      </div>
    );
  }

  if (!access?.canView && !kitsAccess?.canView) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
